import { gql } from "apollo-boost";

const ACTIVITY_QUERY = gql`
  query Activity($searchStr: String, $page: Int = 0, $perPage: Int = 20) {
    activity(searchStr: $searchStr, page: $page, perPage: $perPage) {
      created_at
      updated_at
      settled_at
      returned_at
      description
      category
      amount
      status
      id
      type
      disputed
      dispute_status
      dispute_resolved
    }
    dispute_reasons {
      reason
      description
    }
  }
`;

const USER_NAME_QUERY = gql`
  query UserName {
    user {
      first_name
      last_name
    }
  }
`;

const SUBMIT_DISPUTE = gql`
  mutation DisputeTransaction(
    $transaction_id: ID!
    $disputed_amount: String!
    $form: String!
  ) {
    disputeTransaction(
      transaction_id: $transaction_id
      disputed_amount: $disputed_amount
      form: $form
    ) {
      status
      code
      message
    }
  }
`;

export { ACTIVITY_QUERY, SUBMIT_DISPUTE, USER_NAME_QUERY };
